module.exports = __webpack_public_path__ + "img/index_banner.be650459.jpg";